module.exports = __webpack_public_path__ + "static/media/logo_mh.56848f5c.png";